import React from 'react';
import { CheckCircle, AlertTriangle, AlertOctagon } from 'lucide-react';
export type TrustLevel = 'verified' | 'partial' | 'caution';
interface TrustBadgeProps {
  level: TrustLevel;
  className?: string;
}
export function TrustBadge({
  level,
  className = ''
}: TrustBadgeProps) {
  const config = {
    verified: {
      icon: CheckCircle,
      text: 'Verified Documentation',
      styles: 'border-green-600 text-green-800 bg-green-50'
    },
    partial: {
      icon: AlertTriangle,
      text: 'Partial Docs',
      styles: 'border-yellow-600 text-yellow-800 bg-yellow-50'
    },
    caution: {
      icon: AlertOctagon,
      text: 'Caution - Missing Docs',
      styles: 'border-red-600 text-red-800 bg-red-50'
    }
  };
  const {
    icon: Icon,
    text,
    styles
  } = config[level];
  return <div className={`inline-flex items-center gap-2 px-3 py-1 border rounded-full text-xs font-mono uppercase tracking-wide ${styles} ${className}`} data-id="element-1149">
      <Icon className="w-3 h-3" data-id="element-1150" />
      <span data-id="element-1151">{text}</span>
    </div>;
}